module.exports = __webpack_public_path__ + "img/icon-Stretch-mh.9016f5c5.png";